import { useAtomValue } from 'jotai';
import { MoveTaskOrder } from '@/types/MoveTaskOrder';
import { moveTaskOrderAtom } from '@/store/moveTaskOrderAtom';

export const useMoveTaskOrder = () =>
  useAtomValue(moveTaskOrderAtom) as MoveTaskOrder;
